import React, { useMemo } from "react";
import cx from "classnames";
import { nonNumberHeaders } from "./util";
import { find } from "lodash";
import { Link } from "react-router-dom";
import qs from "query-string";

const ReportLink = ({ name, params, children, ...props }) => {
  return (
    <Link
      to={{
        pathname: `/reports/${name}`,
        search: qs.stringify(params),
      }}
      {...props}
    >
      {children}
    </Link>
  );
};

const ReportCell = ({ value, index, rowType, header }) => {
  const nonNumberHeader = nonNumberHeaders[header?.Value] || !index;
  const { Attributes } = value;

  const { report, link } = useMemo(() => {
    const report = find(Attributes, { Id: "report" })?.Value;
    const link = find(Attributes, { Id: "link" })?.Value;

    return {
      report,
      link,
    };
  }, [Attributes]);

  if (rowType === "Header") {
    return (
      <th className={!nonNumberHeader ? "text-right" : "text-left"}>{value.Value}</th>
    );
  } else {
    return (
      <td
        className={cx(
          rowType === "SummaryRow" ? "font-weight-bold" : "",
          !nonNumberHeader ? "text-right" : "",
          "text-left"
        )}
        style={{
          fontSize: "0.8rem", lineHeight: "1.0rem",
        }}
      >{value.Value ? (        
        report ? (
          <ReportLink {...report}>{value.Value}</ReportLink>
        ) : link ? (
          <Link to={link}>{value.Value}</Link>
        ) : (
          value.Value
        )
      ) : (       
        "-"
      )}
    </td>
    );
  }
};


const ReportC = ({ value, index, rowType, header }) => {
  const nonNumberHeader = nonNumberHeaders[header?.Value] || !index;
  const { Attributes } = value;

  const { report, link } = useMemo(() => {
    const report = find(Attributes, { Id: "report" })?.Value;
    const link = find(Attributes, { Id: "link" })?.Value;

    return {
      report,
      link,
    };
  }, [Attributes]);

  if (rowType === "Header") {
    return (
      <th className={!nonNumberHeader ? "text-end" : "text-left"}>{value.Value}</th>
    );
  } else {
    const isNumericHeader = !nonNumberHeader;

return isNumericHeader ? (
  <th
    className={cx(
      !isNumericHeader ? "text-right" : "text-left",
      rowType === "SummaryRow" ? "font-weight-bold" : ""
    )}
    style={{
      fontSize: "0.8rem", lineHeight: "1.0rem",
      
    }}
  >
    {value.Value ? (
      report ? (
        <ReportLink {...report}>{value.Value}</ReportLink>
      ) : link ? (
        <Link to={link}>{value.Value}</Link>
      ) : (
        value.Value
      )
    ) : (
      "-"
    )}
  </th>
) : (
  <td
    className={cx(
      rowType === "SummaryRow" ? "font-weight-bold" : "",
      !isNumericHeader ? "text-end" : "",
      "text-left"
    )}
    style={{
      fontSize: "0.8rem", lineHeight: "1.0rem",
      
    }}
  >
    {value.Value ? (
      report ? (
        <ReportLink {...report}>{value.Value}</ReportLink>
      ) : link ? (
        <Link to={link}>{value.Value}</Link>
      ) : (
        value.Value
      )
    ) : (
      "-"
    )}
  </td>
);
  }
};


const ReportR = ({ value, headers }) => {
  const { RowType, Cells, Title, Rows } = value;

 if (RowType === "Row") {
    return (
      <tr style={{border: '1px solid #dee2e6'}}>
        {Cells.map((i, idx) => (

          <ReportC
            index={idx}
            value={i}
            rowType={RowType}
            key={idx}
            header={headers[idx]}
          />

        ))}
      </tr>
    );
  } else {
    return null;
  }
};


const ReportRow = ({ value, headers }) => {
  const { RowType, Cells, Title, Rows } = value;

  if (RowType === "Header") {
    return (
      <tr className="table-info">
        {Cells.map((i, idx) => (
          <ReportCell
            index={idx}
            value={i}
            rowType={RowType}
            key={idx}
            header={headers[idx]}
          />
        ))}
      </tr>
    );
  } else if (RowType === "Row" || RowType === "SummaryRow") {
    return (
      <tr>
        {Cells.map((i, idx) => (
          <ReportCell
            index={idx}
            value={i}
            rowType={RowType}
            key={idx}
            header={headers[idx]}
          />
        ))}
      </tr>
    );
  } else if (RowType === "Section") {
    return (
      <>
        {Title ? (
          <tr>
            <td colSpan={headers.length} className="text-left" style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
              {Title}
            </td>
          </tr>
        ) : null}
        {Rows?.map((i, idx) => 
        {
          return (

          <ReportRow key={idx} value={i} headers={headers} />
        )}
        )}
      </>
    );
  } else if (RowType === "BigHead") {
    return (
      <tr>
        <td
          colSpan={headers.length}
          className="text-left"
          style={{ fontWeight: "bold", lineHeight: "1.75rem", fontSize: "1.2rem"}}
        >
          {Title}
        </td>
        {Rows?.map((i, idx) => (
          <ReportRow key={idx} value={i} headers={headers} />
        ))}
      </tr>
    );
  } else {
    return null;
  }
};

export const SalesTaxRows = ({ rows }) => {
  if (!rows.length) return null;

  const headerIndex = rows.findIndex((row) => row.RowType === "Header");
  const header = rows[headerIndex];
  const headers = header.Cells;

  const sections = [];
  let currentSection = [];
  for (let i = headerIndex + 1; i < rows.length; i++) {
    const row = rows[i];
    if (row.RowType === "Section") {
      if (currentSection.length > 0) {
        sections.push(currentSection);
        currentSection = [];
      }
    }
    currentSection.push(row);
  }
  if (currentSection.length > 0) {
    sections.push(currentSection);
  }


  const otherRows = rows.filter((row) => row.RowType !== "Section" && row.RowType === "Row"
  );

  return (
    <>
     <div style={{ marginBottom: 50, maxWidth:400 }}>
        {otherRows.map((row, idx) => (
          <ReportR key={idx} value={row} headers={headers} />
        ))}
      </div>
      <ReportRow value={header} headers={headers} />
      {sections.map((section, idx) => (
        <React.Fragment key={idx}>
          <ReportRow value={section[0]} headers={headers} />
        </React.Fragment>
      ))}
    </>
  );
};

